import type { RecommendationsServingConfig } from '@noths/polaris-client-listings-api';

import { Placement } from '../../../../constants/recommendations';
import type { ListingsAPIRecommendationPlacement } from '../types';
import { UnreachableError } from '../types';

/*
    Maps the "placement" to a Listings API (Vertex) "Serving Config".
    This is also used as the "placementStrategy" (a legacy term from Rich Relevance) value for GA events.
 */
export const getServingConfig = (
  placement: ListingsAPIRecommendationPlacement,
): RecommendationsServingConfig => {
  switch (placement) {
    case Placement.SimilarProducts:
      return 'pdp_similar_products';
    case Placement.SameSeller2:
      return 'pdp_same_seller_2';
    default:
      throw new UnreachableError(
        placement,
        `This placement type ("${placement}") does not have an associated strategy`,
      );
  }
};
